// extracted by mini-css-extract-plugin
export default {"left_arrow":"styles-module__left_arrow___gOSVl","right_arrow":"styles-module__right_arrow___IPJlO","spinner_container":"styles-module__spinner_container___STbjm"};